'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CollectionCard = function (_Component) {
  (0, _inherits3.default)(CollectionCard, _Component);

  function CollectionCard() {
    (0, _classCallCheck3.default)(this, CollectionCard);
    return (0, _possibleConstructorReturn3.default)(this, (CollectionCard.__proto__ || (0, _getPrototypeOf2.default)(CollectionCard)).apply(this, arguments));
  }

  (0, _createClass3.default)(CollectionCard, [{
    key: 'render',
    value: function render() {
      var styles = require('./CollectionCard.scss');
      var thumbnailStyle = {
        backgroundImage: 'url(/beauty-thumb-1.png)',
        backgroundPosition: 'center',
        backgroundSize: 'cover'
      };
      return _react2.default.createElement(
        'div',
        { className: styles.collectionCard },
        _react2.default.createElement(
          'div',
          { className: styles.card },
          _react2.default.createElement('div', { className: styles.thumbnail, style: thumbnailStyle }),
          _react2.default.createElement(
            'div',
            { className: styles.totalItem },
            _react2.default.createElement(
              'div',
              { className: styles.quantity },
              '8'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.text },
              '\u0111\u1ECBa \u0111i\u1EC3m'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.content },
            _react2.default.createElement(
              'div',
              { className: styles.description },
              'C\xE1c ti\u1EC7m nail "ch\u1EA5t ng\u1EA5t" s\u1EBD gi\xFAp b\u1EA1n bi\u1EBFn ho\xE1 v\u1EDBi m\u1ECDi phong c\xE1ch'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.likesCmt },
              _react2.default.createElement(
                'div',
                { className: styles.left },
                _react2.default.createElement(
                  'span',
                  { className: styles.like },
                  _react2.default.createElement('i', { className: 'fa fa-heart-o' }),
                  ' 235'
                ),
                _react2.default.createElement('i', { className: 'fa fa-bookmark-o' }),
                ' 19'
              ),
              _react2.default.createElement('div', { className: styles.right })
            )
          )
        ),
        _react2.default.createElement('div', { className: styles.cardStack1 }),
        _react2.default.createElement('div', { className: styles.cardStack2 })
      );
    }
  }]);
  return CollectionCard;
}(_react.Component);

exports.default = CollectionCard;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AccountManagement/CollectionCard.js
// module id = 1502
// module chunks = 0